import script from "./Buy.vue?vue&type=script&setup=true&lang=js"
export * from "./Buy.vue?vue&type=script&setup=true&lang=js"

import "./Buy.vue?vue&type=style&index=0&id=6b4075bc&scoped=true&lang=less"
import "./Buy.vue?vue&type=style&index=1&id=6b4075bc&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4075bc"]])

export default __exports__